<mat-dialog-content xmlns="http://www.w3.org/1999/html">
  <h2>
    {{ data.title | translate }}
  </h2>
  <mat-card-content>
    <div class="dialog-text">
      {{ data.text | translate }}
    </div>
    <div class="align-right">
      <button mat-raised-button (click)="onConfirm(false)">No</button>
      <button mat-raised-button color="primary" (click)="onConfirm(true)">Yes</button>
    </div>
  </mat-card-content>
</mat-dialog-content>
